const EmptyPicture: React.FC<{ size?: string }> = ({ size }) => (
  <group data-justify="center">
    <icon data-opacity="light" data-icon-size={size ?? 'medium'}>
      imagesmode
    </icon>
  </group>
);

export default EmptyPicture;
